import { BuilderType, portalCacheTags } from './portalApiHelpers';

export type User = {
  id: number;
  portal_user_id?: number;
  email: string;
  first_name: string;
  last_name: string;
  user_type?: string;
  analytics_affiliation?: string;
  usage_affiliation?: string;
  usage_analytics_excluded?: boolean;
  locale?: string;
  temp_unit?: string;
  profile_image_url?: string;
};
export type ResetData = { email: string; password: string; token: string };

export const usersApi = (builder: BuilderType) => ({
  getUsers: builder.query<any, void>({
    query: () => `service/users.json`,
    providesTags: [portalCacheTags.USERS],
  }),

  updateUser: builder.mutation<User, User>({
    query: (user) => ({
      method: 'PUT',
      url: `/service/users/${user.id}.json`,
      body: user,
    }),
    invalidatesTags: [portalCacheTags.USERS],
  }),

  updateUserPassword: builder.mutation<User, User>({
    query: (user) => ({
      method: 'PUT',
      url: `/service/users/${user.id}/update-password.json`,
      body: user,
    }),
    invalidatesTags: [portalCacheTags.USERS],
  }),

  updateChargerUserSettings: builder.mutation<User, User>({
    query: (user) => ({
      method: 'PUT',
      url: `/service/users/${user.id}/update-settings.json`,
      body: user,
    }),
    invalidatesTags: [portalCacheTags.USERS],
    onQueryStarted(queryArgument, mutationLifeCycleApi) {
      const { dispatch } = mutationLifeCycleApi;
    },
  }),

  resetUserPassword: builder.mutation<void, ResetData>({
    query: (resetData) => ({
      method: 'PUT',
      url: `/service/reset-password`,
      body: { ...resetData, password_confirmation: resetData.password },
    }),
  }),
  getUser: builder.query<User, number>({
    query: (userId) => `service/users/${userId}`,
    providesTags: [
      portalCacheTags.USERS,
      (result, error, arg) => ({ type: portalCacheTags.USERS, id: arg }),
    ],
  }),
  getUserAccountsByAccountId: builder.query<User[], number>({
    query: (accountId) => `service/account-users/by-account/${accountId}`,
  }),
});
